module.exports = __webpack_public_path__ + "img/charging-stations-night-mobile.b8127c3f.png";